/* globals console, document, module, require, window */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    //
    user = require('../models/user'),
    FiltersList = require('./filtersList'),
    configuration = require('../utilities/configuration'),
    helpers = require('../utilities/handlebars').helpers,
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'card programs-header-filter sticky-top'
    },
    events: {
        'change select': 'onChangeSelect',
        'click a':       'onClickTab',
        'click button':  'onClickButton',
        'click img':     'onClickButton',
        'keyup [name=keywords]': 'onKeyupKeywords'
    },
    regions: {
        filtersList: 'div[name=filtersList]'
    },
    tagName: 'div',
    template: templates.programsHeaderFilter,
    ui: {
        form: 'form[name=programsHeaderFilter]',
        keywords: 'input[name=keywords]',
        sortby: 'select[name=sortby]',
        clear: 'button[data-action=clear]',
        searchIcon: 'div[name=searchIcon]',
        jumpReports: 'a[name=jumpReports]'
    },
    count: function (count) {
        this.$el.find('h1[name=foundCount]').html(count !== null ? templates.programsHeaderFilterFoundCount({count: count, plural: count !== 1}) : helpers.l10n('foundCountLoading'));
        this.announcements.text('Found ' + count + ' programs');
    },
    clearKeywords: function () {
        this.ui.keywords.val('');
        // this.ui.clear[0].src = this.ui.clear[0].src.replace('enabled', 'disabled');
        this.ui.clear.prop('disabled', true).toggleClass('disabled', true);
        this.ui.searchIcon.toggleClass('active', false);
        this.trigger('filter:programs', null);
    },
    clearSortby: function () {
        this.ui.sortby.val('');
    },
    initialize: function () {
        this.announcements = jQuery('#screenReaderAnnouncementsPolite');
        this.mobile = this.options.mobile;
        this.popout = this.options.popout;
        this.filters = this.options.filters;
        this.templateContext = {
            mobile: this.mobile,
            popout: this.popout
        };
        _.defer(_.bind(function () {
            this.onChangeSelect('initialize'); // push the starting filter
        }, this));
        this.listenToOnce(this.collection, 'request', _.bind(this.onChangeSelect, this)); // apply the current filters...
    },
    onChangeSelect: function (event) {
        if (event.currentTarget) {
            this.trigger('sort:programs', event.currentTarget.value || null);
        }
    },
    onClickButton: function (event) {
        const action = event.currentTarget.dataset.action;
        switch (action) {
            case 'clear':
                this.clearKeywords();
                break;
            case 'popout':
            case 'popoutPrint':
                this.trigger('popout', action);
                break;
            case 'print':
                window.focus();
                window.print();
                break;
            case 'share':
                this.trigger('share:programs');
                break;
            default:
                break;
        }
        return false;
    },
    onClickTab: function (event, fauxEvent) {
        const section = fauxEvent ? event.section : event.currentTarget.dataset.section;
        let propagate = true;
        if (section) {
            this.$el.find('a').toggleClass('active', false);
            this.$el.find('a[data-section=' + section + ']').toggleClass('active', true);
            if (this.getChildView('filtersList')) {
                this.getChildView('filtersList').$el[section === 'filters' ? 'hide' : 'show']();
            }
            if (!fauxEvent) {
                this.trigger('display:section', section);
            }
            propagate = false;
        }
        return propagate;
    },
    onKeyupKeywords: function (event) {
        const target = event.currentTarget,
            length = jQuery(target).val().length;
        this.trigger('filter:programs', target.value);
        this.ui.searchIcon.toggleClass('active', length > 0);
        // this.ui.clear[0].src = this.ui.clear[0].src.replace(length ? 'disabled' : 'enabled', length ? 'enabled' : 'disabled');
        this.ui.clear.prop('disabled', length ? false : true).toggleClass('disabled', length ? false : true);
    },
    onRender: function () {
        this.count(this.collection.length || null);
        if (this.mobile || this.popout) {
            this.filtersList = this.showChildView('filtersList', new FiltersList({collection: this.filters, popout: this.popout}));
            if (!this.popout) {
                this.getChildView('filtersList').$el.hide();
            }
        }
        return this;
    },
    selectedOn: function (date) {
        this.selectedOnDate = date;
        // @acavan! - why the naked div? (shouldn't need to call addClass here...) also, there are two divs w/[name=flitersList]
        this.$el.find('div[name=filtersListItems] div').html(templates.filtersListItem({description: helpers.l10n('programsSelectedOnLabel') + ' ' + helpers.localeDate(date)})).addClass('filters-list-item-wrapper');
    },
    showSection: function (section) {
        this.$el.find('a[data-section=' + section + ']').trigger('click');
    }
});
